import React from 'react';
import axios from 'axios';
import { Form, Input, Button, Modal, Alert } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import stickyError from 'components/stickyError';

import { formItemLayout, tailFormItemLayout } from './formItemLayout.js';

class RevealEmail extends React.Component {
	state = { emailHint: null }
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((error, values) => {
			if (error) {
				this.props.isSubmitted();
				console.error(error);
				return stickyError('Invalid input');
			} else {
				axios.post(apiPath+'/auth/emailHint', values, {withCredentials: true})
					.then(result => {
						this.props.isSubmitted();
						if (!result.data || result.data === '@') return stickyError('No matching user found');
						this.setState({ emailHint: result.data })
					})
					.catch(error => {
						this.props.isSubmitted();
						stickyError('No matching user found')
					});
			}
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		return(
			<div>
				<Alert showIcon type="warning" message={<strong style={{fontSize:'1.2em'}}>If you are still having trouble logging in</strong>}
					description={
						<p>
							Please contact <a href="mailto:techsupport@isevoyages.org">techsupport@isevoyages.org</a>
						</p>
					} />
				<legend>Enter your details</legend>
				<Modal title="The email address that we have on file for you looks something like this"
					visible={this.state.emailHint !== null} closable={false}
					footer={[ <Button onClick={() => this.setState({ emailHint: null })}>Close</Button> ]}>
					<strong>{this.state.emailHint}</strong>
					<br /><br />
					<p>If you're still having trouble, email <a href="mailto:techsupport@semesteratsea.org">techsupport@semesteratsea.org</a>.</p>
				</Modal>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item label="First Name" {...formItemLayout}>
						{getFieldDecorator('Forename', {
							rules: [ {required: true, message: 'First name is required'} ],
							validateTrigger: ['onBlur']
						})(
							<Input />
						)}
					</Form.Item>
					<Form.Item label="Last Name" {...formItemLayout}>
						{getFieldDecorator('Surname', {
							rules: [ {required: true, message: 'Last name is required'} ],
							validateTrigger: ['onBlur']
						})(
							<Input />
						)}
					</Form.Item>
					<Form.Item label="Date of Birth" {...formItemLayout}>
						{getFieldDecorator('BirthDate', {
							rules: [ {required: true, message: 'Date of Birth is required'} ],
							validateTrigger: ['onBlur']
						})(
							<Input placeholder="YYYY-MM-DD" disabled={this.props.disabled} />
						)}
					</Form.Item>
					<SaveButton noAlign icon="unlock"
						buttonText="Reveal My Email Address Hint"
						formItemLayout={tailFormItemLayout}
						loading={this.props.getStatus().submitting} />
				</Form>
			</div>
		);
	}
}

export default withSpin(Form.create()(RevealEmail));



// WEBPACK FOOTER //
// ./src/containers/Login/RevealEmail.jsx